module.exports = __webpack_public_path__ + "img/2.3fc5d68f.jpg";